import {
    VStack, UnorderedList, Box
} from '@chakra-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { useDispatch } from 'react-redux';

import { ModalVariants } from '../../../../../../index';
import { openModal } from '../../../../../modal-manager';
import NewCoursedBgImage from '../../assets/new_courses_promo_bg.svg';
import { ModalFooter } from '../../components/modal-footer/modal-footer';
import * as styled from './new-courses-promo-video.styled';

export function IntroducingNewCoursesModal () {
    const dispatch = useDispatch();

    return (
        <styled.container>
            <styled.wrapper>
                <VStack
                    alignItems={'flex-start'}
                    spacing={0}
                    textAlign={'left'}
                    minH={'427px'}
                    maxH={'1010px'}
                    w={'993px'}
                    pl={'90px'}
                    mb={0}
                    backgroundImage={NewCoursedBgImage}
                    backgroundPosition={'bottom'}
                    backgroundRepeat={'no-repeat'}
                    backgroundColor={'#22bcf7'}
                >
                    <VStack
                        spacing={'16px'}
                        alignItems={'flex-start'}
                        flexDirection={'column'}
                        gap={'0'}
                        w={'100%'}
                        mt={'43px'}
                        color={'neutral.900'}
                        fontWeight={'400'}
                    >
                        <styled.title>{t`promo.Modal.newCourses.Title`}</styled.title>
                        <styled.subTitle>{t`promo.Modal.newCourses.SubTitle`}</styled.subTitle>
                        <Box display={'block'}>
                            <styled.infoText>{t`promo.Modal.newCourses.Summary1`}</styled.infoText>
                            <styled.infoTextBold>{t`promo.Modal.newCourses.Summary2`}</styled.infoTextBold>&nbsp;
                            <styled.infoText>{t`promo.Modal.newCourses.Summary3`}</styled.infoText>
                        </Box>
                        <styled.infoWrapper>
                            <styled.infoText>{t`promo.Modal.newCourses.InfoText`}</styled.infoText>
                            <UnorderedList>
                                <styled.listItem>
                                    <styled.listItemWrapper>
                                        <styled.infoTextBold>{t`promo.Modal.newCourses.InfoText1.bold`}</styled.infoTextBold>&nbsp;
                                        <styled.infoText>{t`promo.Modal.newCourses.InfoText1.normal`}</styled.infoText>
                                    </styled.listItemWrapper>
                                </styled.listItem>
                                <styled.listItem>
                                    <styled.listItemWrapper>
                                        <styled.infoTextBold>{t`promo.Modal.newCourses.InfoText2.bold`}</styled.infoTextBold>&nbsp;
                                        <styled.infoText>{t`promo.Modal.newCourses.InfoText2.normal`}</styled.infoText>
                                    </styled.listItemWrapper>
                                </styled.listItem>
                                <styled.listItem>
                                    <styled.listItemWrapper>
                                        <styled.infoTextBold>{t`promo.Modal.newCourses.InfoText3.bold`}</styled.infoTextBold>&nbsp;
                                        <styled.infoText>{t`promo.Modal.newCourses.InfoText3.normal`}</styled.infoText>
                                    </styled.listItemWrapper>

                                </styled.listItem>
                            </UnorderedList>
                            <styled.infoText mt={'10px'} w={'738px'}>
                                {t`promo.Modal.newCourses.bottomText`}
                            </styled.infoText>
                        </styled.infoWrapper>
                    </VStack>
                </VStack>
                <ModalFooter onClick={() => dispatch(openModal({ variant: ModalVariants.newCoursesVideoModal }))} />
            </styled.wrapper>
        </styled.container>
    );
}

